const escapeQueryPattern = /[\\^$.*+?()[\]{}|]/g;

export default function findTimezone(query, options) {
    if (query.toUpperCase() === 'UTC') {
        // hardcode case for UTC
        return [
            {
                name: 'Etc/UTC',
                offset: '+00:00',
                index: 0,
                label: '(UTC+00:00) UTC',
            },
        ];
    }
    const results = {};
    const keywords = query.trim()
        .split(' ');

    keywords.forEach((word) => {
        let cleanedWord = word;
        const escapeQueryRegexp = new RegExp(escapeQueryPattern.source);
        if (escapeQueryRegexp.test(cleanedWord)) {
            cleanedWord = query.replace(escapeQueryPattern, '');
        }
        options.forEach((option) => {
            const regexp = new RegExp(`.*(${cleanedWord}).*`, 'i');
            const addResult = () => {
                if (!results[option.name]) {
                    results[option.name] = {
                        option,
                        weight: 1,
                    };
                } else {
                    results[option.name].weight += 1;
                }
            };
            // test offsets like 04:00 or -12:30
            if (/-?\d{1,2}:?\d{0,2}/g.test(cleanedWord) && regexp.test(option.offset)) {
                addResult();
            } else if (option.name === cleanedWord || regexp.test(option.name)) {
                addResult();
            }
        });
    });
    return Object.values(results)
        .sort((a, b) => b.weight - a.weight)
        .map(({option}) => option);
}
